import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Scrollbar, A11y, Autoplay } from 'swiper';
import { Container, Row, Col } from "react-bootstrap";
import { LanguageContext } from "../LanguageContext";
import { useContext } from 'react';

const Module4 = ({moduleData}) => {
    const { lang, updateLang } = useContext(LanguageContext);


    return ( 
        <div className="ourcustomer-container text-black">
           <Container >
                <div >
                    <Row data-aos="fade-up"
                        data-aos-anchor-placement="top-bottom">
                        <Col>
                            <div >
                                <h1 className="display-2 fw-bold mb-4" >  {lang === "en" ? "Our customers"  : "Ügyfeleink"} </h1>
                            </div>
                        </Col>
                    </Row>
                    <Row data-aos="fade-up"
                        data-aos-anchor-placement="top-bottom">
                        <Col className="col-lg-8">
                      
                            <p className="fs-5">  {lang === "en" ? "Our aim is to quickly enable our clients to become self-sufficient, so that they can further develop their organizations without consultants. We see ourselves as temporary coaches, working alongside our clients; we work and communicate as peers, support with both our methodical knowledge and our many years of practical experience and we learn together."  :
                             "Célunk, hogy ügyfeleink gyorsan önellátóvá válhassanak, és így tanácsadók nélkül fejleszthessék tovább szervezetüket. Ideiglenes coachoknak tekintjük magunkat, akik ügyfeleink mellett dolgoznak; egyenrangú félként dolgozunk és kommunikálunk, módszertani tudásunkkal és sokéves gyakorlati tapasztalatunkkal egyaránt támogatunk, és együtt tanulunk."}</p>
                        </Col>
                    </Row>
                </div>
            </Container>
            <Swiper data-aos="fade-up"
                data-aos-anchor-placement="top-bottom" className="swiper-container swiper-container-free-mode"
                // install Swiper modules
                modules={[Navigation, Pagination, Scrollbar, A11y, Autoplay]}
                spaceBetween={0}
                slidesPerView={4}
                loop={true}
                speed={8000}
                autoplay={{

                    pauseOnMouseEnter: true,
                    disableOnInteraction: true,
                    reverseDirection: false,

                }}
                navigation
                breakpoints={{
                    375: {

                        slidesPerView: 1,

                    },
                    // when window width is >= 768px
                    768: {

                        slidesPerView: 3,
                    },
                    1280: {
                        slidesPerView: 4
                    }
                }}

                effect="fade"
            >
                <div className="swiper-wapper">

                    {moduleData &&
                        moduleData.map((customer) => (
                            <SwiperSlide className="swiper-slide" key={`${customer.name}`} >
                                <img
                                    style={{maxHeight:'80px', maxWidth:'350px'}}
                                    className="d-block mx-auto img-fluid  p-2"
                                    src={`${customer.image}`}
                                    alt={`${customer.name}`}
                                    key={`${customer.name}`}
                                /></SwiperSlide>
                        ))}


                </div>
            </Swiper>



            
        </div>
     );
}
 
export default Module4;